enum APIErrorType {
  NotAuthenticated = 'NotAuthenticated', // Problem with JWT token
  NotAuthorized = 'NotAuthorized', // Permissions error, user is not authorized to access the resource.
  ClientError = 'ClientError', // Client error, something went wrong.
  ServerError = 'ServerError', // Server error, something went wrong.
  UnprocessableContent = 'UnprocessableContent', // Unprocessable Content - validation errors
}

/**
 * Custom error class for API errors. This helps use handle authentication errors and other errors in a consistent way.
 */
class APIError extends Error {
  status: number;
  statusText: string;
  type: APIErrorType;

  constructor(message: string | undefined, response: Response, request: Request) {
    super(message);

    this.name = `${request.method} ${request.url} ${response.status}`;
    Object.setPrototypeOf(this, APIError.prototype);

    if (response.status === 401 || JSON.parse(message ?? '{}')?.detail === 'Expired JWT') {
      this.type = APIErrorType.NotAuthenticated;
    } else if (response.status === 403) {
      this.type = APIErrorType.NotAuthorized;
    } else if (response.status === 422) {
      this.type = APIErrorType.UnprocessableContent;
    } else if (response.status >= 400 && response.status < 500) {
      this.type = APIErrorType.ClientError;
    } else {
      this.type = APIErrorType.ServerError;
    }

    this.status = response.status;
    this.statusText = response.statusText;
  }
}

export { APIError, APIErrorType };
